import PaymentAppliedItem from '../Domain/PaymentAppliedItem';
import AuthService from './authService';

export default class PaymentsAppliedService {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = {
      Command: '',
      OrderBy: orderById,
      OrderDirection: orderDir,
      PageNumber: pageNumber,
      NumberOfElementsOnAPage: numberOfElements,
      SearchItem: searchItem
    };
    return AuthService.getInstance().CallBackendFunction(
      `/api/VZeusLineItemAppliedClientInvoice/ListByClientInvoiceAsync/?searchParams=${JSON.stringify(
        searchParams
      )}&clearCache=${clearCache}`
    );
  }

  static ConvertDBItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => {
        const newItem = new PaymentAppliedItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }
}
